import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SettingOption from '../components/settingOption';
import '../profileStyles.css';
import { useDispatch, useSelector } from 'react-redux';
import { setEditedProfile, showDialog } from '../../../redux/applicationSlice';
import { deleteProfile, getLanguages, getPgRatings, saveProfile } from '../../../Api/api';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import SmileySelector from '../components/smileySelector';
import Smiley from '../components/Smiley';
import ProfileEditDone from './profileEditDone';
import SmileyWithEditButton from './smileyWithEditButton';
import EditNameInputBox from './EditNameInputBox';
import ViewingRestrictionPopup from './viewingRestrictionPopup';
import LanguagePopup from './LanguagePopup';
import { utility } from '../../../utility/utility';
import { LOCAL_STORAGE_KEY } from '../../../constant';

const ProfileEditPage = () => {
    const navigate = useNavigate();
    const [showSmileySelector, setShowSmileySelector] = useState(false);
    const [showPgRatingSelector, setShowPgRatingSelector] = useState(false);
    const [showLanguageSelector, setShowLanguageSelector] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [pgRatings, setPgRatings] = useState(['', '', '', '', '', '']);
    const [languages, setLanguages] = useState([]);
    const { user, logo, theme, profiles, selectedProfile, editedProfile, ottSettings, dialog } = useSelector((state) => state.application);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log(editedProfile);
        if (!editedProfile?._id && !editedProfile?.addNew) {
            document.location.href = '/';
        }
    }, [editedProfile]);


    const onSave = async () => {
        if (isDeleting || isSaving) { return; }
        if (editedProfile?.Description.length == 0) {
            dispatch(showDialog({
                message: "Profile enter Profile name.",
                confirmText: "Ok",
            }));
            return;
        }
        setIsSaving(true);
        let saveResponse = await saveProfile(editedProfile);
        setIsSaving(false);
        if (!saveResponse.success) {
            //error message
        } else {
            utility.setValue(LOCAL_STORAGE_KEY.language, editedProfile?.Language ?? null);
            dispatch(setEditedProfile(saveResponse.data));
        }
        navigate('/profile');
    }

    const onDelete = async () => {
        if (isDeleting || isSaving) { return; }
        setIsDeleting(true);
        dispatch(showDialog({
            message: "Do you want to delete this profile?",
            showCanclButton: true,
            cancelText: "Cancel",
            confirmText: "Confirm",
            onCancel: () => {
                setIsDeleting(false);
            },
            onConfirm: async () => {
                let deleteResponse = await deleteProfile(editedProfile);
                setIsDeleting(false);
                if (!deleteResponse.success) {
                    setTimeout(() => {
                        dispatch(showDialog({ message: deleteResponse?.message ?? "Error deleting profile. Please try again" }));
                    }, 200);
                } else {
                    navigate('/profile');
                }
            },
        }))
    }

    const showPgRatingSelectorPopup = async () => {
        let res = await getPgRatings();
        if (res.success) {
            setPgRatings(res.data);
            setShowPgRatingSelector(true);
        } else {
            console.log(res);
        }
    }

    const showLanguageSelectorPopup = async () => {
        let res = await getLanguages();
        if (res.success) {
            setLanguages(res.data);
            setShowLanguageSelector(true);
        } else {
            console.log(res);
        }
    }

    const { ref, focusKey, focusSelf, setFocus } = useFocusable({
        focusKey: "profile-edit-page",
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            return true;
        },
    });

    useEffect(() => {
        if (showSmileySelector || showPgRatingSelector || showLanguageSelector || dialog.show) return;
        setFocus('name-profile');
    }, [showSmileySelector, showPgRatingSelector, showLanguageSelector, dialog.show]);


    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} style={{
                display: 'flex', alignItems: 'center', height: '100vh', backgroundColor: theme?.general?.bgColor ?? "#000000", color: theme?.general?.color ?? "#828282", paddingTop: "20px", flexDirection: "column",
                filter: `blur(${!(showSmileySelector || showPgRatingSelector || showLanguageSelector) ? "0px" : "5px"})`, pointerEvents: `${(showSmileySelector || showPgRatingSelector || showLanguageSelector) ? "none" : "auto"}`,
            }}>
                <span style={{ fontSize: "24px", marginBottom: "20px" }}>{editedProfile?._id ? "Edit Profile" : "Add Profile"}</span>
                <ProfileEditDone onSave={onSave} isSaving={isSaving} />
                <SmileyWithEditButton setShowSmileySelector={setShowSmileySelector} showSmileySelector={showSmileySelector} />
                <EditNameInputBox />
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <SettingOption height={"60px"} width={"400px"} title={"Profile Lock"} description={editedProfile?.EnableParentalControl ? 'Control access to this profile' : "Add a 4-digit PIN to this profile"} icon={'lock'} onClick={() => {
                        navigate('profileLock');
                    }} showToggle={!editedProfile?.EnableParentalControl} />
                    <SettingOption height={"60px"} width={"400px"} title={"Viewing Restrictions"} description={(editedProfile?.EnablePgRestriction && editedProfile?.Restricted_PgRatings.length > 0) ? editedProfile?.Restricted_PgRatings.map((pg) => pg?.Description ?? "").join(', ') : "No restrictions"} icon={editedProfile?.EnablePgRestriction ? 'eye-slash' : 'eye'} iconColor={"#007FFF"} showToggle={false} onClick={showPgRatingSelectorPopup} />

                    <SettingOption height={"60px"} width={"400px"} title={"Language"} description={editedProfile?.Language ? (editedProfile?.Language?.Description ?? "English") : "English"} icon={'globe'} iconColor={"#007FFF"} showToggle={false} onClick={showLanguageSelectorPopup} />

                    <SettingOption height={"60px"} width={"400px"} title={"Autoplay Next Episode"} icon={'tv'} iconColor={"red"} toggleValue={editedProfile?.AutoplayNextEpisode} onClick={() => {
                        dispatch(setEditedProfile({ ...editedProfile, AutoplayNextEpisode: !editedProfile?.AutoplayNextEpisode }))
                    }} />
                    {editedProfile?._id && <SettingOption height={"50px"} width={"400px"} onClick={onDelete} isDelete={true} isDeleting={isDeleting} />}
                </div>
            </div>
            {/* smiley selector */}
            <SmileySelector showSmileySelector={showSmileySelector} setShowSmileySelector={setShowSmileySelector} />
            {/* pg rating selector */}
            <ViewingRestrictionPopup pgRatings={pgRatings} showPgRatingSelector={showPgRatingSelector} setShowPgRatingSelector={setShowPgRatingSelector} />
            {/* Language selector */}
            <LanguagePopup languages={languages} languageSelector={showLanguageSelector} setLanguageSelector={setShowLanguageSelector} />
        </FocusContext.Provider>
    );
}

export default ProfileEditPage;